import fetcher from "./http";

export default {
    getTags(appCode) {
        return new Promise((resolve, reject) => {
            fetcher(`/api/v1/${appCode}/tags`, { method: "GET" })
                .then((response) =>
                    response.ok
                        ? response.json()
                        : response.json().then((err) => reject(err))
                )
                .then((data) => resolve(data))
                .catch((error) => reject(error));
        });
    }
};
